import { render, staticRenderFns } from "./ProspectAssignment.vue?vue&type=template&id=3e5cb45e&"
import script from "./ProspectAssignment.vue?vue&type=script&lang=js&"
export * from "./ProspectAssignment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports